import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { trans } from "utils/helpers";
import { getDictionaryListApi } from "./api";

interface AutoCompleteDictionaryPropsType {
  label?: string;
  hasBorder?: boolean;
  valueString?: string;
  disabled?: any;
  resetForm?: boolean;
  required?: boolean;
  fixedparams?: boolean;
  returnObj?: boolean;
  value?: string;
  autoCompleteName?: any;
  DescriptionKey?: any;
  mode?: string;
  ShowMethod?: any; //if useAlllist is true, when input is empty we can get all list instedof relations list
  name: string;
  Change?: (e) => void;
  onChange?: (e) => void;
  returnDictionaryData?: (e) => void;
  baseUrl: any;
  url: any;
  params?: any;
  className?: any;
  searchedHandleFun?: any;
  disabledItems?: any;
  secendUrl?: any;
  preventRenderingAtFirst?:any
  autoFocus?:any
}

export const AutoCompleteDictionary = ({
  label,
  disabled = false,
  value,
  autoCompleteName,
  DescriptionKey,
  valueString,
  mode,
  fixedparams=false,
  returnObj = false,
  resetForm,
  required,
  name = "",
  Change,
  onChange,
  returnDictionaryData,
  baseUrl,
  url,
  params,
  className,
  searchedHandleFun,
  secendUrl,
  disabledItems = [],
  preventRenderingAtFirst=false,
  autoFocus=true
}: AutoCompleteDictionaryPropsType) => {
  const [list, setList] = useState<any>();
  const [valueName, setValueName] = useState<any>();
  const [selectedValue, setSelectedValue] = useState(value ? value : "");
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [allowTyping, setAllowTyping] = useState(valueString);
  const [count, setCount] = useState<number>(0);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const countRef = useRef<any>(0);
  const test=useRef<any>(false)
  const [listBoxPosition, setListBoxPosition] = useState<any>();
  let options_keys, options_values;
  async function getListAsync(search?, id?) {
    try {
      const res = await getDictionaryListApi(baseUrl, url, search, params ,secendUrl,id);
      if(returnDictionaryData){
        returnDictionaryData && returnDictionaryData(res)
      }
              if (res == null || res?.Data || (res && typeof Object.values(res)?.[0]=="object")) {
      
        }
      else{
     if (id) {
        if (res[id] && res[id] != undefined) {
          setValeu(res[id], id);
          setValueName(res[id]);
          if (!returnObj) onChange && onChange(id);
          else onChange && onChange({ Id: id, Name: res[id] });
          Change && Change({ [name]: res[id] });
          setList(res);
          options_values = Object.values(res[id]);
          options_keys = Object.keys(id);
        }
        setSelectedValue(id);
      } else {
        setList(res);
   
        options_values = Object.values(res);
        options_keys = Object.keys(res);
       if(autoFocus){setShow(true);}
      }
      }
      
    } catch (error: any) {}
  }

  const Auto = (e) => {
    setShow(true);
    inputIdRef.current.value = null;
    getListAsync(e.target.value, "");
    setFlag(!flag);
    searchedHandleFun && searchedHandleFun(e.target.value);
  };

  function userSelecter() {
    setValeu(options_values[countRef.current], options_keys[countRef.current]);

    //  setValeu(options_values[countRef.current],Object.keys(options_keys)[countRef.current])
    setShow(false);
  }

  const kydown = (event) => {
 
    
    if (event.key === "ArrowDown") {
      if (countRef.current < options_values.length - 1) {
        countRef.current = countRef.current + 1;
      } else {
        countRef.current = 0;
      }
    }

    if (event.key === "ArrowUp") {
      if (countRef.current > 0) {
        countRef.current = countRef.current - 1;
      } else {
        countRef.current = options_values.length - 1;
      }
    }
    document
      .getElementById("Index" + countRef.current)
      ?.scrollIntoView({ block: "end", behavior: "smooth" });
    setCount(countRef.current);

    if (event.key === "Enter") {
      userSelecter();
    }
  };

  const Check = async (e) => {
    setTimeout(async () => {
      if (
        e.target.value.length == 0 &&
        inputRef.current?.value?.length == 0 &&
        e.target?.value == ""
      ) {
        onChange && onChange({ Id: null, Name: null });
        if (inputIdRef.current) inputIdRef.current.value = null;
      } else {
        try {
          if (!inputIdRef.current.value) {
            const res = await getDictionaryListApi(
              baseUrl,
              url,
              inputIdRef.current.value ? null : e.target.value,
              value,
              secendUrl
            );
            if (Object.keys(res).length == 0) {
            }
            if (Object.keys(res).length == 1) {
              setValeu(Object.values(res)[0], Object.keys(res)[0]);
            }
          }
        } catch (err: any) {}
      }
    }, 200);
    await delay(200);
       // if(!document.activeElement?.className.includes("")){//comment beacuse this condition is always true
      setShow(false)
  //  }

  };

  const delay = (duration) =>
    new Promise((resolve) => setTimeout(resolve, duration));

  const setValeu = (value, id) => {
    if (inputIdRef != null && inputIdRef.current != null) {
      inputRef.current.value = value;
      inputIdRef.current.value = id;
      setList(null);

      if (!returnObj) onChange && onChange(id);
      else onChange && onChange({ Id: id, Name: value });
      setSelectedValue(id);
      setFlag(!flag);
    }
  };

  useEffect(() => {
    if (value) {
      if (valueString) {

        if (!returnObj){ onChange && onChange(value)}else{
        onChange && onChange({ Id: value, Name: valueString });

        }


  
          setValeu(valueString, value);
          setValueName(valueString);
     
     
          options_values = Object.values(valueString);
          options_keys = Object.keys(value);
        
        setSelectedValue(value);



      } else {
        getListAsync(null, value);
      }
    }
  }, [value, resetForm]);
  

    useEffect(() => {
      if((test.current && preventRenderingAtFirst )|| !preventRenderingAtFirst)//اگر موردی داشته باشیم مثل ارجاع ویژه که اتوکامپلیت وابسته باشه به یک چیز دیگه یعنی پارامز هاش فیکس نباشه و مدام در حال تغییر باشه در این حالت باید حتما با تغییر پارامز ها دوباره درخواست بزنیم و لیست جدید بگیریم و این اتفاق به محض لود کامپوننت میوفته یعنی هم کامپوننت لود بشه چون پارامز تغییر کرده میره و درخواست میزنه مثال ارجاع ویژه. در این حالت برای اولین دفعه که کامپوننت لود میشه جلوشو میگیریم
      {
if( params && !!Object.keys(params).length && !fixedparams && (mode!='view'||returnDictionaryData))
      getListAsync(null);
      }else{
        if(!test.current){
        test.current=true}
      }
       
    }, [params && JSON.stringify(params) ,fixedparams]);


  if (list)
    options_values = Object.values(list).map((item) => {
      return item;
    });
  if (list)
    options_keys = Object.keys(list).map((item) => {
      return item;
    });

  function clickToclose(e) {
    let input = document.querySelector("#browser" + name);
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }

  const handleSetListBoxPosition = () => {
    setListBoxPosition(inputRef.current?.getBoundingClientRect());
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("keydown", kydown);
      document.body.addEventListener("click", clickToclose);
    }
    return () => {
      document.removeEventListener("keydown", kydown);
      document.body.removeEventListener("click", clickToclose);
    };
  }, [show, options_values]);

  useEffect(() => {
    if (show) {
      document.addEventListener("scroll", handleSetListBoxPosition, true);
      document.addEventListener("resize", handleSetListBoxPosition, true);
    }
    if (!show) {
      document.removeEventListener("scroll", handleSetListBoxPosition, true);
      document.removeEventListener("resize", handleSetListBoxPosition, true);
    }
    return () => {
      document.removeEventListener("scroll", handleSetListBoxPosition, true);
      document.removeEventListener("resize", handleSetListBoxPosition, true);
    };
  }, [inputRef.current, document, show, window]);

  useEffect(() => {
    setListBoxPosition(inputRef.current?.getBoundingClientRect());
  }, [show]);

  useEffect(() => {
    if (resetForm == true) {
      inputRef.current.value = null;
      inputIdRef.current.value = null;
    }
  }, [resetForm]);


  return (
    <>
      <div className={className?className: "text-box"}>
        {label && (
          <OverlayTrigger
            key={label}
            placement="top"
            delay={{ show: 600, hide: 0 }}
            overlay={
              <Tooltip className="tooltip " id={`button-tooltip-${"reserve"}`}>
                {trans(label)}
              </Tooltip>
            }
          >
            <div
              className="d-flex align-items-center"
              style={{ height: "22px" }}
            >
              <label
                className="text-box__label showDots"
                style={{ maxWidth: "90%" }}
              >
                {trans(`${label}`)}
              </label>
              {required && (
                <span className="text-box__required-sign-for-label text-danger me-1">
                  *
                </span>
              )}
            </div>
          </OverlayTrigger>
        )}
      
      {mode == "view" && disabled && value && valueString ? (
        <>
          <input
            defaultValue={value}
            name={name}
            className="d-none"
            ref={inputIdRef}
          />

          <Textbox
            textboxType="text"
            textboxName={"browser" + name}
            labelText={label}
            defaultValue={valueName ?? valueString}
            resetForm={resetForm}
            mode={mode}
          />
        </>
      ) : (
        <>
          <input
            required={required}
            defaultValue={selectedValue}
            name={name}
            className="d-none"
            ref={inputIdRef}
          />

          {!allowTyping ? (
            <div className="position-relative">
              <input
                required={required}
                autoFocus={!allowTyping && valueName}
                defaultValue={valueName}
                onBlur={Check}
                autoComplete="off"
                onMouseDown={(e) => {
                  e.stopPropagation();
                  Auto(e);
                }}
                onFocus={(e) => {
                  getListAsync(!allowTyping ? e.target.value : null);
                  setShow(true);
                }}
                ref={inputRef}
                list={name}
                name={DescriptionKey?DescriptionKey:("browser" + name)} 
                className={"text-box__box form-control" + " browser" + name}
                type={"text"}
                id={"browser" + name}
                onChange={Auto}
                disabled={disabled || mode == "view"}
              />

              {( show&& (!window.location.href.includes("form-builder"))) && (
                <div
                  className={`text-box__sub-menu mt-1 glassBox border border-1 `}
                  tabIndex={-1}
                  style={{
                    position: "fixed",
                    zIndex: "5",
                    top: `${listBoxPosition?.top + listBoxPosition?.height}px`,
                    left: `${listBoxPosition?.left}px`,
                    width: `${listBoxPosition?.width + "px"}`,
                  }}
                >
                  {(options_values&& mode!="view") &&
                    options_values.map((item, index) => {
                      return (
                        <div
                          id={"Index" + index}
                          className={`${
                            count == index
                              ? "text-box__sub-menu-option-active"
                              : "text-box__sub-menu-option"
                          } ${
                            disabledItems.includes(options_keys[index])
                              ? "disabled text-secondary"
                              : ""
                          }`}
                          onClick={(e) => {
                            if (!disabledItems.includes(options_keys[index]))
                              setValeu(item, options_keys[index]);
                          }}
                          key={options_keys[index]}
                        >
                          {item}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          ) : (
            <input
              required={required}
              defaultValue={valueString}
              onBlur={(e) => {
                onChange && onChange({ Id: " ", Name: e.target.value });
                inputIdRef.current.value = e.target.value;
              }}
              onChange={(e) => {
                setValueName(e.target.value);
              }}
              ref={inputRef}
              name={"browser" + name}
              className={"text-box__box form-control" + " browser" + name}
              type={"text"}
              id={"browser" + name}
              disabled={disabled || mode=='view'}
            />
          )}
        </>
      )}
      </div>
    </>
  );
};
